
// import { forwardRef } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import {Grid,Stack,Box} from '@mui/material'
import MainCard from './MainCard';
import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import CardAnalysis from "./CardAnalysis"
import { round } from '../CommonFunctions';

// header style
const now=new Date();

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));
  function LastYearThisMonth({income,month,color="red"}){
    return (
    <Typography variant="b" color="text.secondary">
            
    You made
    <Typography variant="caption" sx={{ color: `${color || 'primary'}.main` }}>
      {income}
    </Typography>{' '}
    in {month}, last year.
    
  </Typography>
  )
  }
function CardGroup({totalMonthlyAmount,currentVacancy,repairs,inventoryCount,totalAnnual,totalMonthly_lastYear, total_lastYear}) 
{

  
  console.log("totalAnnual :" + totalAnnual)

  return (
    
    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
    <Grid item xs={12} sm={6} md={2.25}>
      <Item><CardAnalysis title="Vacancy" isLoss={false} count={currentVacancy} isMoney={false}
      subTitle="rooms" navigateURL="/tenants/add"  showExtra={false}/></Item>
    </Grid>
    <Grid item xs={12} sm={6} md={2.25}>
      <Item><CardAnalysis title="Inventory Requests" isLoss={true} isMoney={false} count={inventoryCount}
      navigateURL="/inventory" showExtra={false}/></Item>
    </Grid>
    <Grid item xs={12} sm={6} md={2.25}> 
      <Item><CardAnalysis title="Active Repairs" isLoss={false} count={repairs} isMoney={false} 
       navigateURL="/repairs" showExtra={false}/></Item>
    </Grid>
    <Grid item xs={12} sm={6} md={2.5}>
      <Item><CardAnalysis title="This Month Revenue" isLoss={true} count={round(totalMonthlyAmount)} isMoney={true}
      navigateURL="/paymentsHistory" showExtra={true} extraValue1={round(totalMonthly_lastYear)} extraValue2={"Jan, last year"}
       /></Item>
    </Grid>
    <Grid item xs={12} sm={6} md={2.5}>
      <Item><CardAnalysis title="This year's Revenue" isLoss={true} count={round(totalAnnual)} isMoney={true} 
      navigateURL="/paymentsHistory" showExtra={true} extraValue1={round(total_lastYear)} extraValue2={"last year"}/></Item>
    </Grid>
</Grid>
  );
}

export default CardGroup;

